export const IDENTICAL_TWIN_OR_TRIPLET = ['Identical Twin', 'Identical Triplet', 'No'];
